import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { indexOf29nspdgx2e3ap as indexOf } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import {
  add2suhfggl4zvkk as add,
  fromInt2ii0rejb1w62w as fromInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { flushIfNeeded2jf5glmfh5e3h as flushIfNeeded } from './ByteWriteChannel.mjs';
import { writeByte1opghdrkskh5z as writeByte } from './ByteWriteChannelOperations.mjs';
import { get_ONEazvfdh9ju3d4 as get_ONE } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/boxedLong/boxedLong.mjs';
import { IOException1wyutdmfe71nu as IOException } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import { decodeToString2ede220pr5xir as decodeToString } from '../../../../../kotlinx-io-kotlinx-io-bytestring/kotlinx/io/bytestring/ByteString.mjs';
import { replace3le3ie7l9k8aq as replace } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function buildPartialMatchTable($this) {
  var table = new Int32Array($this.i4j_1.q2());
  var j = 0;
  var inductionVariable = 1;
  var last = $this.i4j_1.q2();
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      while (j > 0 && !($this.i4j_1.r2(i) === $this.i4j_1.r2(j))) {
        j = table[j - 1 | 0];
      }
      if ($this.i4j_1.r2(i) === $this.i4j_1.r2(j)) {
        j = j + 1 | 0;
      }
      table[i] = j;
    }
     while (inductionVariable < last);
  return table;
}
function *advanceToNextPotentialMatch($this, $completion) {
  while (!$this.l4j_1.n3x() || (yield* $this.h4j_1.c4j(VOID, $completion))) {
    var nextMatch = indexOf($this.l4j_1, $this.i4j_1.r2(0));
    if (nextMatch === -1n) {
      var tmp = $this.l4j_1;
      checkBounds($this, (tmp instanceof Buffer() ? tmp : THROW_CCE()).q2());
      $this.o4j_1 = add($this.o4j_1, $this.l4j_1.j4f($this.j4j_1.r4i()));
      yield* flushIfNeeded($this.j4j_1, $completion);
    } else {
      checkBounds($this, nextMatch);
      var tmp_0 = $this;
      var tmp_1 = $this.o4j_1;
      var tmp_2 = $this.j4j_1.r4i();
      tmp_0.o4j_1 = add(tmp_1, $this.l4j_1.g4f(tmp_2 instanceof Buffer() ? tmp_2 : THROW_CCE(), nextMatch));
      yield* flushIfNeeded($this.j4j_1, $completion);
      return Unit_instance;
    }
  }
  return Unit_instance;
}
function *checkFullMatch($this, $completion) {
  while (!$this.l4j_1.n3x() || (yield* $this.h4j_1.c4j(VOID, $completion))) {
    var byte = $this.l4j_1.w3x();
    if ($this.p4j_1 > 0 && !(byte === $this.i4j_1.r2($this.p4j_1))) {
      var oldMatchIndex = $this.p4j_1;
      while ($this.p4j_1 > 0 && !(byte === $this.i4j_1.r2($this.p4j_1))) {
        $this.p4j_1 = $this.m4j_1[$this.p4j_1 - 1 | 0];
      }
      var retained = fromInt(oldMatchIndex - $this.p4j_1 | 0);
      checkBounds($this, retained);
      var tmp = $this;
      var tmp_0 = $this.o4j_1;
      var tmp_1 = $this.j4j_1.r4i();
      tmp.o4j_1 = add(tmp_0, $this.n4j_1.g4f(tmp_1 instanceof Buffer() ? tmp_1 : THROW_CCE(), retained));
      if ($this.p4j_1 === 0 && !(byte === $this.i4j_1.r2($this.p4j_1))) {
        yield* writeByte($this.j4j_1, byte, $completion);
        var _unary__edvuaz = $this.o4j_1;
        $this.o4j_1 = add(_unary__edvuaz, get_ONE());
        return false;
      }
    }
    $this.p4j_1 = $this.p4j_1 + 1 | 0;
    if ($this.p4j_1 === $this.i4j_1.q2()) {
      return true;
    }
    $this.n4j_1.w4f(byte);
  }
  return false;
}
function checkBounds($this, extra) {
  if (add($this.o4j_1, extra) > $this.k4j_1) {
    throw IOException().g4h('Limit of ' + $this.k4j_1.toString() + ' bytes exceeded ' + ('while searching for "' + toSingleLineString($this, $this.i4j_1) + '"'));
  }
}
function toSingleLineString($this, $receiver) {
  return replace(decodeToString($receiver), '\n', '\\n');
}
var ByteChannelScannerClass;
function ByteChannelScanner() {
  if (ByteChannelScannerClass === VOID) {
    class $ {
      constructor(channel, matchString, writeChannel, limit) {
        limit = limit === VOID ? 9223372036854775807n : limit;
        this.h4j_1 = channel;
        this.i4j_1 = matchString;
        this.j4j_1 = writeChannel;
        this.k4j_1 = limit;
        // Inline function 'kotlin.require' call
        if (!(this.i4j_1.q2() > 0)) {
          var message = 'Empty match string not permitted for scanning';
          throw IllegalArgumentException().n2(toString(message));
        }
        this.l4j_1 = this.h4j_1.o4i();
        this.m4j_1 = buildPartialMatchTable(this);
        this.n4j_1 = new (Buffer())();
        this.o4j_1 = 0n;
        this.p4j_1 = 0;
      }
      *q4j(ignoreMissing, $completion) {
        this.o4j_1 = 0n;
        while (!this.l4j_1.n3x() || (yield* this.h4j_1.c4j(VOID, $completion))) {
          yield* /*#__NOINLINE__*/advanceToNextPotentialMatch(this, $completion);
          if (yield* /*#__NOINLINE__*/checkFullMatch(this, $completion)) {
            return this.o4j_1;
          }
        }
        if (!ignoreMissing) {
          throw IOException().g4h('Expected "' + toSingleLineString(this, this.i4j_1) + '" but encountered end of input');
        }
        this.o4j_1 = add(this.o4j_1, this.n4j_1.j4f(this.j4j_1.r4i()));
        yield* this.j4j_1.d4j($completion);
        return this.o4j_1;
      }
    }
    initMetadataForClass($, 'ByteChannelScanner', VOID, VOID, VOID, [1, 0]);
    ByteChannelScannerClass = $;
  }
  return ByteChannelScannerClass;
}
//region block: exports
export {
  ByteChannelScanner as ByteChannelScanner1h148q1m3y1ey,
};
//endregion

//# sourceMappingURL=ByteChannelScanner.mjs.map
